export default function LegalPage({ eyebrow, title, children }) {
  return (
    <div className="sect-navy pt-32 pb-24 min-h-screen">
      <div className="bcu-container max-w-4xl">
        <p className="bcu-eyebrow">{eyebrow}</p>
        <h1 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-display leading-[1.02] max-w-3xl">{title}</h1>
        <div className="mt-10 space-y-4 text-[#C7CFDD] leading-relaxed [&_h2]:font-display [&_h2]:text-white [&_h2]:uppercase [&_h2]:tracking-[0.04em] [&_h2]:text-2xl [&_h2]:mt-10 [&_h2]:mb-2 [&_h3]:font-display [&_h3]:text-white [&_h3]:text-lg [&_h3]:mt-6 [&_p]:mt-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_a]:text-[#F7931E] [&_strong]:text-white">
          {children}
        </div>
      </div>
    </div>
  );
}
